export const GB_FEATURES = {
  EXP_GOODBOT_INQUIRY_ENGAGEMENT: 'exp_goodbot_inquiry_engagement',
  EXP_MINI_APP_INQUIRY_ENGAGEMENT: 'exp_mini_app_inquiry_engagement',
  EXP_PUPPY_PAGE: 'exp_puppy_page',
  EXP_RESULTS_CTA: 'exp_results_cta',
  EXP_SEARCH_RESULTS_HEADER: 'exp_search_results_header',
  EXP_SEARCH_FILTERS: 'exp_search_filters',
  EXP_PUPPY_CARD_AVAILABILITY_INFO: 'exp_puppy_card_availability_info'
};
